export default {
  formId: "class-form",
  formField: {
    className: {
      name: "className",
      label: "Class Name",
      type: "text",
      placeholder: "Enter a class name",
      size: "large",
      errorMsg: "Class Name is required.",
    },
    classLevel: {
      name: "classLevel",
      label: "Class Level",
      type: "select",
      size: "large",
      isMulti: false,
      placeholder: "Select a class level",
      errorMsg: "Class Level is required.",
    },
    organization: {
      name: "organization",
      label: "Organization",
      type: "select",
      size: "large",
      isMulti: false,
      placeholder: "Select an organization",
      errorMsg: "Organization is required.",
    },
    subOrganization: {
      name: "subOrganization",
      label: "Sub Organization",
      type: "select",
      size: "large",
      isMulti: false,
      placeholder: "Select a sub organization",
      errorMsg: "Sub Organization is required.",
    },
  },
};
